module.exports = __webpack_public_path__ + "img/cancer.ad3aff28.png";